export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6813.ba8641bc.jpg";